import React from "react";
//#region types
import { ManualVoucherProps } from "models/propTypes/voucherPropsTypes";
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import Voucher from "./voucher";
import { ViewPanel } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ManualVoucher: React.FC<ManualVoucherProps> = (props) => {
  const { voucher } = props;

  return (
    <ViewPanel
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TransactionList)}
      icon={IconDefinitionConstants.WList}
    >
      <Voucher
        key={`voucher-${voucher.number}`}
        parentId={voucher.number}
        voucherNumber={voucher.number}
        voucherText={voucher.text ?? ""}
        bookingDate={voucher.bookingDate}
        currency={voucher.originalCurrency ?? ""}
        series={voucher.seriesShortName ?? ""}
        transactions={
          voucher.transactions
            ? voucher.transactions.map((transaction) => ({
                account: transaction.accountNumber,
                accountName: transaction.accountName ?? "",
                transactionText: transaction.text ?? "",
                dimensions: transaction.dimensions?.map((d) => d.name ?? "") ?? [],
                amount: transaction.amount,
              }))
            : []
        }
      />
    </ViewPanel>
  );
};

export default ManualVoucher;
